@import url('../../../../node_modules/@splidejs/splide/dist/css/splide-core.min.css');

:host {
  @include reset-host;
}

:host .external-article-section {
  --title-color: #{$white};
  --paragraph-color: #{$white};

  padding: rem(64) $gutter;
  overflow: clip;

  background: $color-purple;

  // Layout
  .container {
    max-width: $max-width;
    margin: 0 auto;
  }

  .head {
    max-width: rem(520);
  }
}

// Splide
$splide--arrow-color: $white;

:host .splide {
  width: 100%;
  margin: rem(40) 0;

  @include mq('max', 'xs') {
    margin: rem(30) auto;
  }

  &__track {
    overflow: visible;
  }

  &__list {
    align-items: stretch;
    height: 100%;
  }

  &__slide {
    transition: all $transition;

    @include mq('min', 'md') {
      &:not(.is-visible) {
        opacity: 0.4;
      }
    }
  }

  &__arrows {
    margin-top: rem(40);

    @include mq('min', 'xl') {
      display: none;
    }

    @include mq('max', 'md') {
      display: none;
    }
  }

  &__arrow {
    @include square(56);
    color: $splide--arrow-color;

    background: transparent;
    border: initial;
    border: 2px solid $splide--arrow-color;
    border-radius: rem(100);
    cursor: pointer;

    &:not(:last-child) {
      margin-right: rem(24);
    }

    &:focus-visible {
      outline: 1px solid rgba($black, 0.8);
      outline-offset: 3px;
    }

    &:disabled {
      opacity: 0.2;
    }
  }

  &__arrow-icon {
    font-size: rem(56);
  }

  &__pagination {
    display: flex;
    justify-content: center;
    height: rem(2);
    margin: rem(-4);
    margin-top: rem(14);
    @include mq('min', 'md') {
      display: none;
    }

    &__page {
      width: rem(22);
      height: rem(2);
      margin: rem(4);

      background: $splide--arrow-color;
      border: initial;
      opacity: 0.25;

      &.is-active {
        opacity: 1;
      }
    }
  }
}
